import React, { Component } from "react";
import Head from "next/head";
import PropTypes from "prop-types";
import NProgress from "components/NProgress";
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import ReactPixel from 'react-facebook-pixel';
// import TagManager from 'react-gtm-module';
import { clearInnityAds, loadInnitySpinner } from '../utils/innity';

// const tagManagerArgs = {
//     gtmId: 'GTM-WCJSTPT',
// }

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit * 2,
        color: theme.palette.text.secondary,
        [theme.breakpoints.up('sm')]: {
            margin: '50px 0px'
        },
    },
    innityAd: {
        padding : 60,
        textAlign: 'center'
    }
});

class AdInnityAdPageOne extends Component {
    constructor(props){
        super(props);
        this.state = {
            ssrDone: false,
        };
    }
    
    render() {
        const { classes } = this.props;
        return(
          <div>
            <Head>
              <title>Ads Test</title>
            </Head>
            <NProgress />
            <p style={{ textAlign: 'center' }}>Innity Responsive Billboard Ad</p>
            <div className='ads-style' style={{textAlign : 'center'}}>
              <span dangerouslySetInnerHTML={
                        {__html: '<div><iframe id="innty_res_billboard" src="/static/ads/innity_res_billboard.html" frameborder="0" width="300" height="250" style="overflow:hidden" scrolling="no" border="0"></iframe></div>'}
                    }
              />
            </div>
            {/* Innity Spinner Ad */}
            <div className={classes.innityAd} id="innity-spinner-ad" />
          </div>
        )
    }
    componentDidMount () {
        // ************ start facebook pixel ***********

        if (!window.PX_INITIALIZED) {
            const advancedMatching = { em: '' }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/pixel-with-ads/conversion-tracking#advanced_match
            const options = {
                autoConfig: true, 	// set pixel's autoConfig
                debug: false, 		// enable logs
            };
            ReactPixel.init('548709379041005', advancedMatching, options);
            // ReactPixel.init('355678948310337', advancedMatching, options);
            window.PX_INITIALIZED = true
        }
        // ReactPixel.pageView(); 					// For tracking page view
        //  ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
        //  ReactPixel.trackCustom( event, data ) 	// For tracking custom events
        // ************ end facebook pixel ***********
        this.setState({
            ssrDone: true,
        });
        clearInnityAds();
        loadInnitySpinner("innity-spinner-ad");
    }

    componentDidUpdate(previousProps, previousState){
        // TagManager.dataLayer(tagManagerArgs)

        clearInnityAds();
        loadInnitySpinner("loadInnitySpinner");
    }
}

export default withStyles(styles)(AdInnityAdPageOne);
